import { render, staticRenderFns } from "./SplashPageBuilder.vue?vue&type=template&id=7f98e879&scoped=true"
import script from "./SplashPageBuilder.vue?vue&type=script&lang=js"
export * from "./SplashPageBuilder.vue?vue&type=script&lang=js"
import style0 from "./SplashPageBuilder.vue?vue&type=style&index=0&id=7f98e879&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f98e879",
  null
  
)

export default component.exports